<div class="navbar">
  @if (title()) {
    <div class="title-container">
      <h1 class="title">{{ title() }}</h1>
    </div>
  }
  <ng-content />
  <ng-container #container />
</div>
